/**
 * Properties for the `sales_order_created` event.
 *
 * The event stays the analytics drift-check reference (see @/lib/posthog) —
 * the count is still the database's job. The customer fields are here so the
 * browser-side view can be segmented (walk-in vs named customer, which
 * customer keeps coming back) without a database query; a UUID is not PII and
 * the walk-in placeholder is flagged rather than counted as a customer.
 */
export interface OrderCreatedInput {
    orderId: string | undefined
    sourceChannel: string
    itemCount: number
    totalAmount: number
    customerId: string
    walkInCustomerId: string
    extra?: Record<string, string | number | boolean>
}

export function orderCreatedProps(input: OrderCreatedInput) {
    const isWalkIn = input.customerId === input.walkInCustomerId
    return {
        order_id: input.orderId,
        source_channel: input.sourceChannel,
        item_count: input.itemCount,
        total_amount: input.totalAmount,
        customer_id: isWalkIn ? undefined : input.customerId,
        is_walkin: isWalkIn,
        ...input.extra,
    }
}
